import {requirePermission} from '@/modules/auth/permissions'
import {useGetSupportiveMedicationDrug} from '@/modules/drug-catalog/supportive-medications/api/use-get-supportive-medication-drug'
import {SupportiveMedicationForm} from '@/modules/drug-catalog/supportive-medications/components'
import {EditResourceTitle} from '@/shared/components/ui/edit-resource-title'
import {NewSupportiveMedicationPageSearchSchema} from '@/modules/drug-catalog/supportive-medications/schemas'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/drug-catalog/supportive-medications/new')({
  beforeLoad: requirePermission('catalogue.manage'),
  component: NewSupportiveMedicationPage,
  validateSearch: NewSupportiveMedicationPageSearchSchema,
})

function NewSupportiveMedicationPage() {
  const {t} = useTranslate('substances')
  const {drugId} = Route.useSearch()
  const [supportiveMedication] = useGetSupportiveMedicationDrug(drugId)

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={
          drugId ? (
            <EditResourceTitle label={t('edit_supportive_medication_title')} name={supportiveMedication?.name} />
          ) : (
            t('new_supportive_medication_title')
          )
        }
        description={t('new_supportive_medication_description')}
      />

      <SupportiveMedicationForm drugId={drugId} />
    </NewResourceFormContainer>
  )
}
